/* eslint-disable no-unused-vars */
/* import db from '@/plugins/dexie'; */
import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  actions: {

    async findPorSessao(_, idSessao) {
      const { data } = await apiempresaweb.get(`inventarioitens/por-sessao/${idSessao}`);
      return data;
    },
    async findSemCadastro(_, idSessao) {
      const { data } = await apiempresaweb.get(`inventarioitens/sem-cadastro/${idSessao}`);
      return data;
    },
    async findOpenItems(_, { idUsuario }) {
      const { data } = await apiempresaweb.get(`inventarioitens/abertos/${idUsuario}`);
      return data;
    },
    async create(_, body) {
      const { data } = await apiempresaweb.post('inventarioitens', body);
      return data.resultado;
    },

    async update(_, { id, body }) {
      const { data } = await apiempresaweb.put(`inventarioitens/quantidade/${id}`, body);
      return data;
    },

    async fetchProductSummary(_, { idUsuario }) {
      const { data } = await apiempresaweb.get(`inventarioitens/resumo-produtos/${idUsuario}`);
      return data;
    },

    async fetchSessionSummaryByUser(_, idSessao) {
      const { data } = await apiempresaweb.get(`inventarioitens/resumo-por-usuario/${idSessao}`);
      return data;
    },

    async findNotCountedInSession(_, idSessao) {
      const { data } = await apiempresaweb.get(`inventarioitens/nao-contados/${idSessao}`);
      return data;
    },

    async findAllWithCountInSession(_, idSessao) {
      const { data } = await apiempresaweb.get(`inventarioitens/todos-com-contagem/${idSessao}`);
      return data;
    },

    async findAllItemsInSession(_, idSessao) {
      const { data } = await apiempresaweb.get(`inventarioitens/todos-da-sessao/${idSessao}`);
      return data;
    },

    async validarSemCadastro({ commit }, { idInventario, codigo }) {
      const response = await apiempresaweb.get(`/inventarioitens/validar-sem-cadastro/${idInventario}/${codigo}`);
      return response;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
